const LOAD_DATA_PROFILE         = 'LOAD_DATA_PROFILE'
const LOAD_DATA_PROFILE_SUCCESS = 'LOAD_DATA_PROFILE_SUCCESS'
const LOAD_DATA_PROFILE_FAILED  = 'LOAD_DATA_PROFILE_FAILED'
const UNMOUNT_DATA_PROFILE      = 'UNMOUNT_DATA_PROFILE'

const initialState = {
  loading: true,
  data: null,
  message: null
}

const profileReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_DATA_PROFILE:
      return {
        ...state,
        loading: true,
        data: null
      }
    case LOAD_DATA_PROFILE_SUCCESS:
      return {
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS'
      }
    case LOAD_DATA_PROFILE_FAILED:
      return {
        ...state, 
        loading: false,
        data: null,
        message: 'FAILED'
      }
    case UNMOUNT_DATA_PROFILE:
      return { 
        ...state, 
        loading: true,
        data: null
      }
    default:
      return state
  }
}
export default profileReducer